/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import React from "react";
import CardLayout from "../Cards/CardLayout";
import Loader from "../feedBacks/loader";
import NoContent from "../feedBacks/NoContent";
import { IDevice } from "../../utils/interfaces";
import CardError from "../feedBacks/CardError";
import SingleTable from "./SingleTable";
import { useUtils } from "../../customHooks/useUtils";
import { formatCustomDate } from "../../utils/utils";
import { COLORS } from "../../utils/constants";

function DeviceDetailTable({
  isLoading,
  error,
  data,
  site_status,
}: {
  isLoading: boolean;
  error: string;
  data: IDevice[];
  site_status: { last_seen: string; time: string };
}) {
  const { t } = useUtils();
  const deviceData = data && data.length > 0 ? data[0] : null;
const confirmLastSeen = (lastSeen: Date, time: Date): string => {
  const diffInMs = time.getTime() - lastSeen.getTime(); // Difference in milliseconds
  const diffInMinutes = diffInMs / (1000 * 60); // Convert to minutes
  if (diffInMinutes > 3) {
    return `${t("common.offline")} since ${formatCustomDate(lastSeen.toString())}`;
  }

  return `${t("common.online")}`;
};

  // Transform the data for the SiteDetailsTable format
  const detailsData = deviceData
    ? {
        [t("site_details.asset_name")]: deviceData.asset_name,
        [t("site_details.asset_type")]: `${deviceData?.asset_type
          .charAt(0)
          .toUpperCase()}${deviceData?.asset_type.slice(1)}`,
        [t(
          "site_details.asset_coordinate"
        )]: `${deviceData?.latitude}, ${deviceData?.longitude}`,
        [t("site_details.nature_of_ownership")]:
          deviceData?.nature_of_position || "N/A",
        [t("site_details.type_of_installation")]:
          deviceData?.nature_of_transformer || "N/A",
        [t("site_details.asset_capacity")]: `${deviceData?.asset_capacity}kVA`,
        [t("site_details.year")]: deviceData?.transformer_year,
        [t("site_details.location")]: deviceData?.address_of_tfo,
        [t("common.status")]: confirmLastSeen(new Date(site_status?.last_seen), new Date(site_status?.time)),
      }
    : {};

  return (
    <CardLayout
      title={t("site_details.title")}
      className="!w-full !lg:min-w-[450px] flex-1"
    >
      {isLoading ? (
        <div className="flex justify-center items-center h-full w-full">
          <Loader />
        </div>
      ) : error ? (
        <CardError message={t("feedback_msg.error_fetching")} />
      ) : !deviceData ? (
        <NoContent message={t("feedback_msg.no_data")} />
      ) : (
        <SingleTable
          data={detailsData}
          titleColumnWidth="40%"
          titleColumnStyle={{ fontWeight: "bold" }}
          styleValueCell={(value, title) =>
            title === t("common.status") && value === t("common.online")
              ? {
                  fontWeight: "bold",
                  backgroundColor: COLORS.GREEN,
                }
              : title === t("common.status") && typeof value === "string" && value.includes(t("common.offline"))
              ? {
                  fontWeight: "bold",
                  backgroundColor: COLORS.PRIMARY_LIGHT,
                }
              : {}
          }
        />
      )}
    </CardLayout>
  );
}

export default DeviceDetailTable;
